import { z } from 'zod';

export const chiefComplaintSchema = z.object({
    emotion: z
        .array(
            z.enum([
                'Anxious',
                'Burntout',
                'Confused',
                'Content',
                'Encouraged',
                'Excited',
                'Exhausted',
                'Fearful',
                'Frustrated',
                'Guilty',
                'Happy',
                'Hopeful',
                'Hopeless',
                'Lonely',
                'Motivated',
                'Nervous',
                'Numb',
                'Overwhelmed',
                'Sad',
                'Satisfied',
                'Shame',
                'Stressed',
                'Unmotivated',
                'Worthless',
                'Worried',
            ]),
        )
        .optional(),
    emotionOther: z.string().trim().optional(),
    about: z.string().trim().optional(),
    directQuote: z.string().trim().optional(),
    relatedTo: z
        .array(
            z.enum([
                'Alcohol Use',
                'Anxiety',
                'Attention/Concentration',
                'Childhood experiences',
                'Communication',
                'Cultural experiences',
                'Dating',
                'Divorce/Separation',
                'Eating behaviors',
                'Family conflict',
                'Fearfulness',
                'Friends/Social life',
                'Fulfillment',
                'Grief/Loss',
                'Health',
                'Identity',
                'Loneliness',
                'Major life changes',
                'Medication/side effects',
                'Motivation',
                'Organization',
                'Overwhelm',
                'Parenting',
                'Perinatal issues',
                'Relationships (partner/spouse)',
                'Relationships (other)',
                'Sadness',
                'School',
                'Self harm/Intent to harm',
                'Sexuality',
                'Sleep',
                'Social support',
                'Substance use',
                'Symptoms management',
                'Thinking',
                'Time Management',
                'Trauma',
                'Values/beliefs',
                'Work',
                'Worry',
            ]),
        )
        .optional(),
    relatedToOther: z.string().trim().optional(),
});
